import {Octicon} from '@primer/react/deprecated'
import {clsx} from 'clsx'

import styles from './StatusIcon.module.css'

export type StatusIconProps = {
  iconColor: string
  backgroundColor?: string
  icon: React.ElementType
  size: 12 | 16 | 20 | 24
  absolute?: boolean
  backgroundClassName?: string
}

export function StatusIcon({
  iconColor,
  icon,
  size = 12,
  backgroundColor = 'var(--fgColor-onEmphasis)',
  absolute = true,
  backgroundClassName,
}: StatusIconProps) {
  let innerSize
  let margin

  switch (size) {
    case 12:
      innerSize = '10px'
      margin = '1px'
      break
    case 16:
      innerSize = '12px'
      margin = '2px'
      break
    case 20:
      innerSize = '16px'
      margin = '2px'
      break
    case 24:
      innerSize = '16px'
      margin = '4px'
      break
  }

  return (
    <div
      className={clsx(
        styles.outerContainer,
        absolute ? styles.outerContainerAbsolute : styles.outerContainerRelative,
        backgroundClassName,
      )}
    >
      <div
        className={styles.innerCircle}
        style={{
          width: innerSize,
          height: innerSize,
          left: margin,
          top: margin,
          backgroundColor,
        }}
      />
      <span className={styles.icon} style={{color: iconColor}}>
        <Octicon icon={icon} size={size} />
      </span>
    </div>
  )
}
